import React from "react";
import { useTranslation } from "react-i18next";

import { BillingStatus } from "../../types/billings";
import { billingStatusColorMap } from "../../utils/billings";
import { Tag } from "../Tag";

interface IBillingStatusTagProps {
  value: BillingStatus;
}

export const BillingStatusTag: React.FC<IBillingStatusTagProps> = ({ value }) => {
  const { t } = useTranslation();
  const label = t(`billingStatus.${value}`);
  const color = billingStatusColorMap[value] || BillingStatus.New;

  return <Tag label={label} color={color} />;
};
